import type { ArticleType } from '@/types/ArticleType';
import mapWpPost from '@/utils/functions/wordpress/mapWpPost';

const mapWpPosts = (result: any[]): ArticleType[] => {
    return result.map(r => mapWpPost(r));
};

export default mapWpPosts;
